import {
  cibDiscord,
  cibStripe,
  cibWindows,
  cibAndroid,
  cilTrash
} from '@coreui/icons'

import {
  cilArrowRight,
  cilArrowLeft,
  cilFingerprint,
  cilBalanceScale,
  cilTransfer,
  cilDollar,
  cilLockLocked,
  cilUser,
  cilUserUnfollow,
  cilSpeedometer,
  cilWarning,
  cilMoon,
  cilSun,
  cilDevices
} from '@coreui/icons'

export const iconsSet = Object.assign({}, {
    cilArrowRight,
    cilArrowLeft,
    cilFingerprint,
    cilBalanceScale,
    cilTransfer,
    cilDollar,
    cilLockLocked,
    cilUser,
    cilUserUnfollow,
    cilSpeedometer,
    cilMoon,
    cilSun,
    cilWarning,
    cilDevices
  },
  {
    cibDiscord,
    cibStripe,
    cibWindows,
    cibAndroid,
    cilTrash
  });
